import moment from 'moment';
import 'moment/locale/fr';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import carPlaceholder from '../../assets/user.png';
import { useAxios } from '../../utils/hook/useAxios';

moment.locale('fr');

function AnnonceStatus({ annonce }) {
  if (!annonce) {
    return (
      <span className="mc-status mc-status--none">
        <ion-icon name="alert-circle-outline"></ion-icon>Pas d'annonce
      </span>
    );
  }
  if (annonce.status === '1' || annonce.status === 1) {
    return (
      <span className="mc-status mc-status--ok">
        <ion-icon name="checkmark-circle"></ion-icon>Annonce active
      </span>
    );
  }
  if (annonce.status === '0' || annonce.status === 0) {
    return (
      <span className="mc-status mc-status--pending">
        <ion-icon name="hourglass-outline"></ion-icon>En attente de validation
      </span>
    );
  }
  return (
    <span className="mc-status mc-status--off">
      <ion-icon name="close-circle"></ion-icon>Désactivée
    </span>
  );
}

function VoitureAnnonce({ propsData }) {
  const [annonces, setAnnonces] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const axios = useAxios();

  useEffect(() => {
    let cancelled = false;

    setAnnonces([]);

    axios
      .get('/vehicleAnnonces/getbyvehiculeid/' + propsData.id)
      .then(({ data }) => {
        if (!cancelled && Array.isArray(data)) {
          setAnnonces(data);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          console.error('Erreur chargement annonces :', error);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [axios, propsData.id]);

  const image = propsData?.images?.split(',')[0];
  const hasAnnonce = annonces.length > 0;
  const firstAnnonce = annonces[0];
  const carName =
    `${propsData?.VehicleModel?.marque ?? ''} ${propsData?.VehicleModel?.modele ?? ''}`.trim();
  const plate = propsData?.UserProfile?.immatriculation;

  return (
    <>
      {/* ── Carte véhicule ── */}
      <article className="mc-car-card">
        <div className="mc-car-main">
          {/* Image */}
          <div className="mc-car-media">
            <img src={image || carPlaceholder} alt={carName || 'Véhicule'} />
          </div>

          {/* Contenu */}
          <div className="mc-car-body">
            {/* Titre + menu */}
            <div className="mc-car-head">
              <div className="mc-car-title">
                <h3 className="mc-car-name">{carName}</h3>
                {plate && <span className="mc-plate">{plate}</span>}
              </div>

              {/* Menu 3 points */}
              <div className="dropdown flex-shrink-0">
                <button
                  type="button"
                  className="mc-icon-btn"
                  aria-expanded={menuOpen}
                  aria-label="Actions sur le véhicule"
                  onClick={() => setMenuOpen((prev) => !prev)}
                >
                  <span className="mc-ellipsis" aria-hidden="true">
                    ⋮
                  </span>
                </button>

                {menuOpen && (
                  <ul className="dropdown-menu dropdown-menu-end mc-menu show">
                    <li>
                      <Link
                        className="dropdown-item mc-menu-item"
                        to={`/account/settings/vehicule/${propsData.id}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        <span className="mc-menu-icon" aria-hidden="true">
                          ⚙
                        </span>
                        Paramètres
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item mc-menu-item"
                        to={`/account/voiture/${propsData.id}/calendar/0`}
                        onClick={() => setMenuOpen(false)}
                      >
                        <span className="mc-menu-icon" aria-hidden="true">
                          ▦
                        </span>
                        Calendrier
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item mc-menu-item"
                        to={`/confirmmodel/${propsData.id}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        <span className="mc-menu-icon" aria-hidden="true">
                          ✎
                        </span>
                        Compléter
                      </Link>
                    </li>

                    <li>
                      <hr className="dropdown-divider" />
                    </li>

                    <li>
                      <button
                        type="button"
                        className="dropdown-item mc-menu-item mc-menu-item--danger"
                        onClick={() => {
                          setMenuOpen(false);
                          // Ajouter ici la logique de suppression du véhicule.
                        }}
                      >
                        <span className="mc-menu-icon" aria-hidden="true">
                          ×
                        </span>
                        Supprimer
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            </div>

            {/* Date ajout */}
            <p className="mc-car-date">
              <ion-icon name="time-outline"></ion-icon>
              Ajouté {moment(propsData?.createdAt).fromNow()}
            </p>

            {/* Statut annonce */}
            <AnnonceStatus annonce={hasAnnonce ? firstAnnonce : null} />
          </div>
        </div>

        {/* ── Barre d'actions ── */}
        <div className="mc-car-actions">
          <Link to={'/account/settings/vehicule/' + propsData.id} className="mc-car-action">
            <ion-icon name="settings-outline"></ion-icon>
            Config
          </Link>

          <Link to={'/account/voiture/' + propsData.id + '/calendar/0'} className="mc-car-action">
            <ion-icon name="calendar-outline"></ion-icon>
            Calendrier
          </Link>

          {hasAnnonce ? (
            <a
              href={'/location-voiture/' + firstAnnonce.vehiculeAnnonceId}
              className="mc-car-action mc-car-action--primary"
            >
              <ion-icon name="eye-outline"></ion-icon>
              Voir annonce
            </a>
          ) : (
            <Link to={'/confirmmodel/' + propsData.id} className="mc-car-action mc-car-action--cta">
              <ion-icon name="add-circle-outline"></ion-icon>
              Créer annonce
            </Link>
          )}

          {hasAnnonce && (
            <button
              type="button"
              className="mc-car-action"
              data-bs-toggle="modal"
              data-bs-target={'#annonceModalList' + propsData.id}
            >
              <ion-icon name="list-outline"></ion-icon>
              Annonces
            </button>
          )}
        </div>
      </article>

      {/* ── Modal liste annonces ── */}
      <div
        className="modal fade mc-modal"
        id={'annonceModalList' + propsData.id}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title mc-modal-title">
                <ion-icon name="list-outline"></ion-icon>
                Annonces — {carName}
              </h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Fermer"
              />
            </div>
            <div className="modal-body">
              {annonces.map((annonce) => (
                <a
                  key={annonce.vehiculeAnnonceId}
                  href={'/location-voiture/' + annonce.vehiculeAnnonceId}
                  className="mc-modal-item"
                  data-bs-dismiss="modal"
                >
                  <div>
                    <strong>
                      {annonce.Vehicle?.VehicleModel?.marque}{' '}
                      {annonce.Vehicle?.VehicleModel?.modele}
                    </strong>
                    <small>
                      {annonce.reservationPrice} €/jour · #{annonce.vehiculeAnnonceId}
                    </small>
                  </div>
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VoitureAnnonce;
